import React from "react";

import { templates } from "@reactivated";

import { FinancingModal } from "../apps/financing/FinancingModal";

export const Template = (
    _props: templates.FinancingModalTemplate,
): React.JSX.Element => {
    return <FinancingModal />;
};
